import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import CovidVaccineConfirmation from "./CovidVaccineConfirmation";
import * as d from "../../reducers/domainReducer";
import Spinner from "../common/spinner";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import { getFirstName } from "../../helpers/formatting";
import ConfirmationModal from "../common/ConfirmationModal";
import NotAuthorized from '../common/NotAuthorized';
import FeatureDisabled from "../common/FeatureDisabled";
import MessageSpinner from "../common/MessageSpinner";
import Covid19ReviewNSubmit from '../appointments/Covid19ReviewNSubmit';
import Covid19VaccineScheduleError from './Covid19VaccineScheduleError';
import Covid19VaccineAppointmentInfo from "./Covid19VaccineAppointmentInfo";
import {get} from 'lodash';

class Covid19VaccineSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.refOurStepManager = React.createRef();
        const searchModel = this.getSearchModel();
        let { 
            provId: providerId = null, visitTypeId, departmentId, stime: startTime, etime: endTime, loc: currentLocation = '', xid,
            provAddress: address, provAddress: {phone = ""} = {}, patientInstructions, locationInstructions, timeString, visitTypeDescription: description
        } = searchModel || {};
        const {currentUser: patient = undefined, patientEmail: email = ""} = props;       
        visitTypeId = isNaN(parseInt(visitTypeId)) ? "" : visitTypeId;        
        departmentId = isNaN(parseInt(departmentId)) ? "" : departmentId;   
        const eid = patient ? patient.eid : "";
        const displayName = patient ? patient.displayName : "";    

        let scheduleData = {
            providerId,
            visitTypeId,
            departmentId,
            createPatient: {},
            showSpinner: false,
            scheduleErrorMessage: null,
            currentLocation,
            visit: {
                visitType: {
                    id: visitTypeId,
                    description,
                    idType: "External"
                },
                department: {
                    id: departmentId,
                    name: "",
                    idType: "External",
                    phone,
                    address
                },
                reasonForVisit: "COVID-19 Vaccine",
                patient: {
                    id: eid,
                    loginId: "",
                    name: displayName,
                    phoneNumber: "",
                    email: email,
                    address1: "",
                    address2: "",
                    city: "",
                    state: "",
                    zip: ""
                },
                patientInstructions,
                locationInstructions,
                startTime,
                endTime,
                timeString,
                xid
            }
        };

        this.state = {
            createPatient: {},
            showSpinner: false,
            scheduleErrorMessage: null,
            scheduleCompleted: false,           
            startingStep: 0,
            currentStep: 0,
            selectedSlot: null,
            scheduleData: scheduleData,
            isFromSeeMore: providerId && !startTime && !endTime,
            providerData: null,
            baseURL: window.location.pathname,
            showNotAuthorizedPage: false,
            providerMessage: ""
        };
        window.formChanged = false;
    }

    componentDidMount() {
        logUI("MBHWeb.UI.CovidVaccine.Schedule.ComponentDidMount", new Date(), Tools.getURLPath());
        const { isFromSeeMore, scheduleData: { currentLocation = '', visitTypeId = '' } } = this.state || {};
        const { providerSearchModel, serverData, searchGenericProviders, currentUser } = this.props;
        const { location = null, radius = "25", sortBy = "Distance" } = providerSearchModel || {};
        const searchModel = this.getSearchModel();        
        if (isFromSeeMore) {
            let dtStart = new Date();
            let isMinor = currentUser && currentUser.ageYears && currentUser.ageYears <= 17 ? true : false;
            
            let { CovidVaccineSlotsInDays: noOfDays = 28, covid19VaccineVisitTypeId, covid19VaccineVisitTypeIdForMinor} = serverData || {};
            let dtEnd = Tools.addDays(dtStart, noOfDays);
            let startDateStr = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
            let endDateStr = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;

            const genericSearchModel = {
                location: currentLocation || location,
                radius,
                sortBy,
                visitTypeId: (serverData && serverData.enableCOVID19Booster) ? visitTypeId : isMinor ? covid19VaccineVisitTypeIdForMinor : covid19VaccineVisitTypeId,
                startDate: startDateStr,
                endDate: endDateStr,
                page: "1",
                perPage: "12"
            };
            searchGenericProviders(genericSearchModel, this.loadMoreSlots);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        let state = this.state;
        const searchModel = this.getSearchModel();
        let {
            provId, visitTypeId, departmentId, stime, etime, provAddress, patientInstructions, 
            locationInstructions, timeString, visitTypeDescription
        } = searchModel;
        const {scheduleData, scheduleData: {visit = {}, providerId = ""}} = this.state;
        //Handle Error Page slot nagvation.
        if ((prevState.visit !== this.state.visit || get(prevProps, 'location.state', {}) !== get(this.props, 'location.state')) &&
            (scheduleData && visit && ((provId && providerId !== provId) || (visitTypeId && visit.visitType.id !== visitTypeId) ||
            (departmentId && visit.department.id !== departmentId) || (stime && visit.startTime !== stime) || (etime && visit.endTime !== etime)))) {
            
            state = {
                ...state,
                scheduleData: {
                    ...state.scheduleData,
                    providerId: provId || providerId,
                    visitTypeId: visitTypeId || state.scheduleData.visitTypeId,
                    departmentId: departmentId || state.scheduleData.departmentId,
                    patientInstructions: patientInstructions || state.scheduleData.patientInstructions,
                    locationInstructions: locationInstructions || state.scheduleData.locationInstructions,
                    visit: {
                        ...visit,
                        visitType: {
                            ...visit.visitType,
                            id: visitTypeId || visit.visitType.id, 
                            description: visitTypeDescription || visit.visitType.description
                        },
                        department: {
                            ...visit.department,
                            id: departmentId || visit.department.id,
                            address: provAddress || visit.department.address,
                            phone: provAddress && provAddress.phone || visit.department.phone
                        },
                        startTime: stime || visit.startTime,
                        endTime: etime || visit.endTime,
                        timeString: timeString || visit.timeString
                    }
                }
            }
            
            this.setState(state);
        }
    }

    componentWillUnmount() {
        this.props.clearReduxState();
    }

    componentDidCatch(err, info) {
        console.error(err, info);
        let json = { error: err, componentStack: info };
        //logUI("MBHWeb.UI.Schedule.ComponentDidCatch", new Date(), Tools.getURLPath(), JSON.stringify(json));
        logUI("MBHWeb.UI.MainErrorBoundary.ComponentDidCatch", new Date(), Tools.getURLPath(),
            JSON.stringify(err), JSON.stringify(info)
        );
        throw err; // if we're not going to be a property Error boundary, throw it  :)
    }

    saveSlot = (selectedSlot, providerMessage) => {
        let state = this.state;
        const { 
            departmentId, patientInstructions, locationInstructions, visitTypeId, visitTypeDisplayName, startTime, endTime, timeString
        } = selectedSlot;
        const {scheduleData, scheduleData: {visit = {}}} = this.state;
        if (selectedSlot) {
            state = {
                ...state,
                scheduleData: {
                    ...scheduleData,
                    visitTypeId, departmentId, patientInstructions, locationInstructions,
                    visit: {
                        ...visit,
                        startTime, endTime, timeString,
                        visitType: {
                            ...visit.visitType,
                            id: visitTypeId, description: visitTypeDisplayName
                        },
                        department: {
                            ...visit.department,
                            id: departmentId,
                        }
                    }
                },
                selectedSlot,
                providerMessage
            }
        }
        this.setState(state);
    }

    loadMoreSlots = (providers) => {
        const { providerId } = this.state.scheduleData
        const { providerResults } = providers;
        if (providerResults && providerResults.length > 0) {
            for (let i = 0; i < providerResults.length; i++) {
                if (providerResults[i] && providerResults[i].provider && providerResults[i].provider.epicID === providerId) {
                    const prov = providerResults[i];
                    //update provider location.
                    let state = this.state;
                    const currentProvloc = prov.provider.locations && prov.provider.locations.length > 0 && prov.provider.locations[0];
                    if (currentProvloc) {
                        const { locationStreet1: street1, locationStreet2: street2, locationCity: city, locationState,
                             locationZip: zip, locationPhone: phone
                        } = currentProvloc;
                        let address = { street1, street2, city, state: locationState, zip, phone };
                        state.scheduleData.visit.department.address = address;
                        state.scheduleData.visit.department.phone = currentProvloc.locationPhone ? currentProvloc.locationPhone : "";
                    }
                    state.providerData = prov;
                    this.setState(state);
                    break;
                }
            }
        } else {
            this.setState({ providerData: null });
        }
    }

    getSearchModel() {
        const { 
            location, 
            location: {
                search = "", 
                state = {}, 
                state : {
                    scheduleData = {},
                    scheduleData: {
                        patientInstructions = [], 
                        locationInstructions = [], 
                        timeString = "", 
                        visitTypeDisplayName: visitTypeDescription = ""
                    } = {},
                    provAddress = "",
                    xid = ""
                } = {}
            } = {},
        } = this.props || {};

        let searchModel = search ? queryString.parse(search) : {};
        searchModel = location && state ? { ...searchModel, provAddress, xid } : searchModel;
        searchModel = scheduleData ? {...searchModel, patientInstructions, locationInstructions, timeString, visitTypeDescription} : searchModel;                
        searchModel = !searchModel.scheduleType ? { ...searchModel, scheduleType: 'OpenSchedule'} : searchModel;
        
        return searchModel;
    }

    callbackOnLeave = () => {
    }

    blockNavigation = (nextLocation) => {
        return true;
    }

    scheduleAppointment = () => {
        const { userToken: token, currentUser, userDetails, isCovidVaxScheduleEligible, enableCovidScheduleAuthFeature, patientLoginId } = this.props || {};
        const {Email: userEmail, Givenname: firstName, Surname: lastName} = userDetails;
        const { createPatient, scheduleData } = this.state;
        const { visit, providerId } = scheduleData;
        let id = currentUser ? currentUser.externalId : "";
        let idType = "External";
        let patientModel = {};

        if (enableCovidScheduleAuthFeature && !isCovidVaxScheduleEligible) {
            this.setState({ showNotAuthorizedPage: true });
            return;
        }

        if (createPatient && Object.keys(createPatient).length > 0) {
            const {email, dateOfBirth = "", gender = "", nationalIdentifier = ""} = createPatient;
            patientModel = {
                firstName,
                lastName,
                email: email || userEmail,
                dateOfBirth,
                gender,
                nationalIdentifier,
                departmentId: visit.department.id,
                departmentIdType: visit.department.idType
            };

            patientModel = createPatient.phoneNumbers && createPatient.phoneNumbers.length > 0 ?
                {...patientModel, phoneNumbers: this.state.createPatient.phoneNumbers} : patientModel;

            if (createPatient.houseNumber) {
                const {houseNumber, streetLine1, city, state, zipCode} = createPatient;
                patientModel = {...patientModel, houseNumber, streetLine1, city, state, zipCode};
            }
        }

        let scheduleModel = null;
        
        scheduleModel = {
            scheduleType: "OpenSchedule",
            loginId: patientLoginId,
            myChartId: "",
            proxyPatientId: id,
            proxyPatientIdType: idType,
            visitTypeId: `${visit.visitType.id}`,
            visitTypeIdType: visit.visitType.idType,
            providerId: providerId,
            providerIdType: "PROVID",
            departments: [
                {
                    departmentId: `${visit.department.id}`,
                    departmentIdType: visit.department.idType,
                    time: [
                        {
                            startTime: visit.startTime,
                            endTime: visit.endTime
                        }
                    ]
                }
            ],
            comments: visit.reasonForVisit
        };

        // insurance is only supplied when creating a patient...it won't exist otherwise.
        const insurance = createPatient.insurance;
        if (insurance && insurance.insuranceName !== "") {
            const {insuranceName, memberNumber, groupNumber, subscriberId} = insurance;
            scheduleModel.insurance = {insuranceName, memberNumber, groupNumber, subscriberId};
        }       

        if (this.props.currentUser && this.props.hasMyChart) {
            logUI("MBHWeb.UI.CovidVaccine.Schedule.ScheduleAppointment", new Date(), Tools.getURLPath(), scheduleModel, 'isVaccineSearch');
            // schedule appointment for existing patient...
            this.props.scheduleAppointment(scheduleModel, token, this.scheduleCallCompleted);
        }
        else {
            logUI("MBHWeb.UI.CovidVaccine.Schedule.CreatePatientAndScheduleAppt", new Date(), Tools.getURLPath(), null, 'isVaccineSearch');
            // create patient and schedule appointment...
           // this.props.createAndSchedule(patientModel, scheduleModel, token, this.scheduleCallCompleted);
        }

        //Load step at top of page
        if (typeof window !== 'undefined') {
            window.scrollTo(0, 0);
        }       
    }

    scheduleCallCompleted = (bSuccessful, sErrorMessage) => {
        const { serverData, providerSearchModel, currentUser } = this.props;
        let { scheduleErrorMessage, scheduleData: { currentLocation = '', visitTypeId = '' }, isFromSeeMore} = this.state || {};
        const { location = null, radius = "25", sortBy = "Distance" } = providerSearchModel || {};
        const searchModel = this.getSearchModel(); 
        if (bSuccessful) {
            if (scheduleErrorMessage !== "") {
                scheduleErrorMessage = "";
            }
        }
        else {
            if (scheduleErrorMessage !== sErrorMessage) {
                scheduleErrorMessage = sErrorMessage;
            }
            let isMinor = currentUser && currentUser.ageYears && currentUser.ageYears <= 17 ? true : false;
            if (serverData.enableVaccineSearchInScheduleErrorPage) {
                const dtStart = new Date();
                const { CovidVaccineSlotsInDays: noOfDays = 28 } = serverData || {};
                let dtEnd = Tools.addDays(dtStart, noOfDays)
                const startDateStr = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
                const endDateStr = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;

                let genericSearchModel = {
                    startDate: startDateStr,
                    endDate: endDateStr,
                    location: currentLocation || location,
                    radius,
                    sortBy,
                    visitTypeId: (serverData && serverData.enableCOVID19Booster) ? visitTypeId : isMinor ? serverData.covid19VaccineVisitTypeIdForMinor : serverData.covid19VaccineVisitTypeId,
                    page: "1",
                    perPage: "12"
                };
                //if (isFromSeeMore) {
                //    const dtStart = searchModel && searchModel.stime ? new Date(searchModel.stime) : new Date();
                //    const { CovidVaccineSlotsInDays: noOfDays = 28 } = serverData || {};
                //    let dtEnd = Tools.addDays(dtStart, noOfDays)
                //    const startDateStr = `${dtStart.getFullYear()}-${dtStart.getMonth() + 1}-${dtStart.getDate()}`;
                //    const endDateStr = `${dtEnd.getFullYear()}-${dtEnd.getMonth() + 1}-${dtEnd.getDate()}`;
                //    genericSearchModel = {
                //        ...genericSearchModel,
                //        startDate: startDateStr,
                //        endDate: endDateStr
                //    };
                //}
                this.props.searchGenericProviders(genericSearchModel);
            }
        }
        this.setState({ scheduleCompleted: true, scheduleErrorMessage });
    }    

    onUserSwitched = (userSelected, index) => {
        this.userSelected = userSelected;
        this.props.switchToMyChartUser(userSelected, index);
    }

    render() {
        const { scheduleErrorMessage, showSpinner, scheduleCompleted, scheduleData, providerData, isFromSeeMore, selectedSlot, showNotAuthorizedPage, providerMessage } = this.state;
        const { searchRunning, currentUser, hasMyChart, serverData, primaryUser, scheduleAppointmentFailed, scheduleAppointmentSuccess, scheduleAppointmentPending,
            epicEHRDown, providers, providerSearchModel, scheduleAppointmentError, isCovidVaxScheduleEligible, enableCovidScheduleAuthFeature, headerProxyUser, proxyListLoading, proxyListFailure } = this.props; 
        const { visit, providerId } = scheduleData;
        const displayFirstName = currentUser && currentUser.displayName ? " " + getFirstName(currentUser.displayName) : "";
        const spinnerMessage = `Thanks${displayFirstName}, we&#39re working on it.` + '<br /> This may take a moment.';
        //Return to Non authorized page, if user doesn't have feature enabled.
        if (enableCovidScheduleAuthFeature && !isCovidVaxScheduleEligible) {
            return (((proxyListLoading || !headerProxyUser) && !proxyListFailure)  ? <Spinner /> : <NotAuthorized / >);
        }

        if (showNotAuthorizedPage || (currentUser && currentUser.externalId && headerProxyUser && headerProxyUser.externalId && 
                                            currentUser.externalId !== headerProxyUser.externalId)) {
            return <NotAuthorized />;
        }

        return (hasMyChart && (enableCovidScheduleAuthFeature === false || (enableCovidScheduleAuthFeature && isCovidVaxScheduleEligible)) && !epicEHRDown)
            ? <div className="container-fluid body-content open-schedule-container covid-vaccine-schedule">
                <div className="row">
                    {!scheduleCompleted
                        ? <div className="col-12 maxWidth-content">
                            {(isFromSeeMore && !selectedSlot)
                                ? <Covid19VaccineAppointmentInfo steptitle="Appointment Info" visit={visit}
                                    providerData={providerData} selectedProviderId={providerId} saveSlot={this.saveSlot}
                                    providerSearchModel={providerSearchModel} />
                                : (visit && visit.visitType && visit.visitType.id && visit.department && visit.department.id && visit.startTime && visit.endTime) ?
                                    <Covid19ReviewNSubmit steptitle="Review & Submit"
                                        visit={visit}
                                        onSubmit={() => { this.scheduleAppointment() }}
                                        currentUser={currentUser} hasMyChart={hasMyChart} primaryUser={primaryUser} userDetails={this.props.userDetails}
                                        scheduleErrorMessage={scheduleErrorMessage} scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy} continueButtonText="Schedule It!" serverData={serverData} providerMessage={providerMessage} isFromSeeMore={isFromSeeMore} />
                                    :
                                    (!currentUser && (proxyListLoading || !headerProxyUser) && !proxyListFailure) ? <Spinner /> : <Covid19VaccineScheduleError
                                        xid={currentUser && currentUser.externalId ? currentUser.externalId : ""}
                                        showCustomError={true}
                                        headerMsg="It looks like you’re trying to schedule your vaccine"
                                        bodyMsg="Please select a day and time to continue scheduling an appointment."
                                        retryBtnText="Schedule Appointment"
                                    />
                            }
                          </div>
                        : <div className="col-12">
                            {scheduleAppointmentFailed
                                ? <Covid19VaccineScheduleError
                                    showSlots={serverData.enableVaccineSearchInScheduleErrorPage && !searchRunning}
                                    providers={providers}
                                    initiateRetry={() => { this.setState({ scheduleCompleted: false }); }}
                                    providerSearchModel={providerSearchModel}
                                    providerId={providerId}
                                    selectedSlotTime={visit.endTime}
                                    xid={visit && visit.xid ? visit.xid : ""}
                                    scheduleAppointmentError={scheduleAppointmentError}
                                />
                                : <CovidVaccineConfirmation
                                    scheduleAppointmentPending={scheduleAppointmentPending}
                                    scheduleAppointmentSuccess={scheduleAppointmentSuccess}                                    
                                    scheduleAppointmentFailed={scheduleAppointmentFailed}
                                    visit={visit}
                                    primaryUser={primaryUser}
                                    scheduleAppointmentForProxy={serverData && serverData.scheduleAppointmentForProxy}
                                    serverData={serverData} providerMessage={providerMessage} isFromSeeMore={isFromSeeMore}                                 
                                />
                            }
                        </div>
                    }
                </div>
                {!scheduleCompleted &&
                    <ConfirmationModal when={!scheduleAppointmentSuccess || !scheduleAppointmentFailed} noReload blockNavigation={this.blockNavigation} callbackOnLeave={this.callbackOnLeave} switchToMyChartUser={this.onUserSwitched}
                        blockUserSwitchMsg="The account cannot be switched while scheduling." blockUserSwitch
                    />
                }
                {(showSpinner || (searchRunning && !scheduleCompleted)) && <Spinner />}
                {(scheduleAppointmentPending === true || (searchRunning && scheduleCompleted)) && <MessageSpinner message={spinnerMessage} />}
            </div>
            : <FeatureDisabled />;
    }
}

const mapStateToProps = (state, ownProps) => {
    const pl = [];
    if (state.domain.pl) {
        state.domain.pl.forEach((proxy) => {
            pl.push(d.hydrateProxyUser(proxy));
        });
    }
    const primaryUserDomain = d ? d.hydrateProxyUser(state.domain.pu) : {};
    const primaryUserSSO = state.sso.primaryUser;
    let primaryUser = primaryUserDomain || primaryUserSSO;
    let cur = d ? d.hydrateProxyUser(state.domain.cu) : {};

    if (state.openScheduling.createdPatient) {
        const created = state.openScheduling.createdPatient;
        cur = {
            displayName: created.name,
            externalId: created.ids && created.ids.length > 0 ? created.ids[0].id : ""
        };
    }

    return {
        providerSchedule: state.openScheduling.providerSchedule,
        proxyListLoading: state.memberships.proxyListLoading,
        proxyListFailure: state.memberships.proxyListFailure,
        scheduleAppointmentSuccess: state.openScheduling.scheduleAppointmentSuccess,
        scheduleAppointmentFailed: state.openScheduling.scheduleAppointmentFailed,
        scheduleAppointmentPending: state.openScheduling.scheduleAppointmentPending,
        scheduleAppointmentError: state.openScheduling.scheduleAppointmentError,
        primaryUser: primaryUser,
        currentUser: cur,
        serverData: state.session.serverData,
        epicEHRDown: state.common.epicEHRDown,
        hasMyChart: state.domain.hm,
        patientLoginId: state.domain.un,
        patientEmail: state.domain.e,
        userToken: state.domain.t,
        userDetails: state.sso.userDetails,
        externalID: state.domain.cu ? state.domain.cu.ei : null,
        myChartID: state.domain.cu ? state.domain.cu.mi : null,
        searchRunning: state.providers.searchRunning,
        providers: state.providers.providers,
        providerSearchModel: state.providers.searchModel,
        headerProxyUser: state.memberships.currentUser,
        isCovidVaxScheduleEligible: state.memberships.hasAuthorizedFeatureSchedCovidVax,
        enableCovidScheduleAuthFeature: state.session.serverData && state.session.serverData.enableCovidScheduleAuthFeature ? state.session.serverData.enableCovidScheduleAuthFeature : false,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        scheduleAppointment: (model, token, scheduleCallBack) => {
            dispatch({
                type: types.OPEN_SCHEDULE_SCHEDULE,
                model: model,
                token: token,
                callBack: scheduleCallBack,
                isVaccineSearch: true
            });
        },
        searchGenericProviders: (searchModel, callback) => {
            dispatch({ type: types.SEARCH_FOR_GENERIC_PROVIDER, searchModel: searchModel, callback: callback });
        },
        clearReduxState: () => {
            dispatch({ type: types.OPEN_SCHEDULE_CLEAR_REDUX_STATE });
        },
        switchToMyChartUser: (user, index) => {
            dispatch({ type: types.SWITCH_USER_SAGA, user, index });
            dispatch({ type: types.SWITCH_TO_PHARMACY_USER, pharmacyUser: null });
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Covid19VaccineSchedule));